module.exports = __webpack_public_path__ + "img/equipment_name@3x.17eac6ab.png";